import { SET_CURRENT_ECGS } from './ecg.type'

export const setCurrentEcg = (data) => async (dispatch) => {
    dispatch({
        type: SET_CURRENT_ECGS,
        payload: data,
    })
}
